<template>
    <div class="experience-container">
        <h1 class="experience-h1">Privacy Policy for Business Filter Chrome Extension</h1>
        <div class="privacy-policy-p-container">
            <p class="privacy-p">
                Effective Date: 02/21/2021
            </p>
            <p class="privacy-p">
                Business Filter ("we," "us," or "our") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, and safeguard your information when you use our Chrome extension (the "Extension"). By installing and using the Extension, you agree to the collection and use of information in accordance with this policy.
            </p>
            <p class="privacy-p privacy-header">
                1. Information We Collect
            </p>
            <p class="privacy-p">
                We do not collect personally identifiable information (PII) such as your name, address, email address, or phone number. The following types of data may be collected during your use of the Extension:
            </p>
            <p class="privacy-p">
                Web History: We may access the list of web pages you visit on specific domains to enhance the filtering experience and apply user-defined business listing filters.
            </p>
            <p class="privacy-p">
                User Activity: We may monitor user interactions within the Extension (e.g., clicks on business listings) to improve the functionality and responsiveness of the Extension.
            </p>
            <p class="privacy-p">
                Website Content: We may interact with and process website content (text, images, hyperlinks) to apply filters according to your specified criteria.
            </p>
            <p class="privacy-p privacy-header">
                2. How We Use Your Information
            </p>
            <p class="privacy-p">
                We use the collected information for the following purposes:
            </p>
            <p class="privacy-p">
                To provide and maintain the Extension.
            </p>
            <p class="privacy-p">
                To improve, personalize, and expand our Extension's features and functionality.
            </p>
            <p class="privacy-p">
                To analyze how users interact with the Extension to enhance the user experience.
            </p>
            <p class="privacy-p privacy-header">
                3. Data Sharing and Disclosure
            </p>
            <p class="privacy-p">
                We do not sell or transfer your data to third parties outside of the approved use cases. We do not use or transfer your data for purposes unrelated to the Extension's primary functionality. We also do not use or transfer your data to determine creditworthiness or for lending purposes.
            </p>
            <p class="privacy-p privacy-header">
                4. Data Security
            </p>
            <p class="privacy-p">
                We take the security of your information seriously. However, please be aware that no method of transmission over the internet or method of electronic storage is 100% secure.
            </p>
            <p class="privacy-p privacy-header">
                5. Your Rights
            </p>
            <p class="privacy-p">
                You have the right to:
            </p>
            <p class="privacy-p">
                Request access to the personal data we hold about you.
            </p>
            <p class="privacy-p">
                Request that we correct any inaccuracies in your data.
            </p>
            <p class="privacy-p">
                Request the deletion of your data, subject to certain legal exceptions.
            </p>
            <p class="privacy-p privacy-header">
                6. Changes to This Privacy Policy
            </p>
            <p class="privacy-p">
                We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page with a revised effective date. We encourage you to review this Privacy Policy periodically for any changes.
            </p>
            <p class="privacy-p privacy-header">
                7. Contact Us
            </p>
            <p class="privacy-p">
                If you have any questions about this Privacy Policy, please contact us at:
                <br>
                jackgumina@gmail.com
                <br>
                <br>
                <br>
            </p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PrivacyPolicy',
    data: function() {
    return {

        };
    },
    methods: {

    }
}
</script>